// frontend/src/components/common/Modal.jsx
import React from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";

export default function Modal({ isOpen, onClose, title, children, maxWidth = "max-w-2xl" }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto flex items-end sm:items-center justify-center">
      {/* iOS Backdrop */}
      <div
        className="fixed inset-0 bg-black/45 backdrop-blur-md transition-opacity duration-300"
        onClick={onClose}
      />

      {/* iOS Modal / Bottom Sheet Container */}
      <div
        className={`relative w-full ${maxWidth} 
          max-sm:fixed max-sm:bottom-0 max-sm:inset-x-0 max-sm:rounded-t-[2.25rem] max-sm:rounded-b-none 
          sm:rounded-3xl 
          bg-white/95 dark:bg-[#1C1C1E]/95 backdrop-blur-2xl
          p-5 sm:p-7 shadow-2xl border border-black/5 dark:border-white/10 
          max-sm:animate-sheet-up transition-all z-10 my-0 sm:my-8 mx-auto`}
      >
        {/* iOS Mobile Grab Handle */}
        <div className="sm:hidden w-10 h-1 bg-gray-300 dark:bg-gray-600 rounded-full mx-auto mb-3" />

        {/* Modal Header */}
        <div className="flex items-center justify-between pb-3.5 mb-4 border-b border-black/[0.05] dark:border-white/[0.08]">
          <h3 className="text-lg font-bold text-gray-900 dark:text-white tracking-tight">
            {title}
          </h3>
          <button
            onClick={onClose}
            className="p-1.5 rounded-full bg-black/[0.05] dark:bg-white/[0.1] text-gray-500 hover:text-gray-900 dark:hover:text-white ios-tap transition-colors"
          >
            <XMarkIcon className="w-4 h-4" />
          </button>
        </div>

        {/* Content with iOS smooth scrolling */}
        <div className="max-h-[75vh] sm:max-h-[72vh] overflow-y-auto pr-1">
          {children}
        </div>
      </div>
    </div>
  );
}

